import * as React from "react";
const ReactModal = require('react-modal');
import EventModal from "./event-modal";
import moment from "moment";
export default class EventItem extends React.Component {
    constructor(props) {
        super(props);
        this.toggleModal = () => {
            this.setState({ toggle: !this.state.toggle });
        };
        this.onClick = () => {
            this.props.updateSelectedEvent ?
                this.props.updateSelectedEvent() :
                this.toggleModal();
        };
        this.onError = () => {
            this.setState({ imgPath: "" });
        };
        this.state = {
            toggle: false,
            imgPath: this.props.imgPath || ""
        };
    }
    render() {
        let imgPath = this.state.imgPath;
        let img = imgPath ? React.createElement("div", { className: "event-img" },
            React.createElement("img", { alt: "pic", src: imgPath, onError: this.onError })) : null;
        let premiumModal = this.props.PremiumEvent ? React.createElement("div", { className: "event-modal-premium" }, "PREMIUM") : null;
        let imgModal = React.createElement("div", { className: "event-modal-img" },
            imgPath ? React.createElement("img", { alt: "pic", src: imgPath }) : null,
            React.createElement("div", { className: "event-modal-header" },
                premiumModal,
                React.createElement("i", { className: "fa fa-times-circle", onClick: this.toggleModal })));
        let premium = this.props.PremiumEvent ? React.createElement("div", { className: "event-premium" }, "PREMIUM") : null;
        let modal = this.state.toggle ?
            React.createElement(EventModal, Object.assign({}, this.props, { imgPath: imgPath, toggle: this.state.toggle, toggleModal: this.toggleModal }))
            : null;
        return (React.createElement("div", { className: this.props.PremiumEvent ? "event-item featured" : "event-item", onClick: this.onClick },
            img,
            modal,
            React.createElement("div", { className: "event-body" },
                React.createElement("div", { className: "event-date" },
                    React.createElement("span", { className: "date" }, moment(new Date(this.props.StartDate)).format('DD')),
                    React.createElement("span", { className: "month" }, moment(new Date(this.props.StartDate)).format('MMM'))),
                React.createElement("div", { className: "event-content" },
                    React.createElement("p", { className: "event-title" }, this.props.Name),
                    React.createElement("p", { className: "event-location" }, this.props.LocationName),
                    React.createElement("p", { className: "event-details" }, this.props.Licensee && React.createElement("a", { href: `/Licensee/Index/${this.props.Licensee.Number}` }, "Contact store for details")))),
            React.createElement("div", { className: "event-footer" },
                premium,
                React.createElement("div", { className: "footer-content" }))));
    }
}
;
//# sourceMappingURL=event-item.js.map